import { buildMessage, IS_NOT_EMPTY_OBJECT, ValidateBy } from 'class-validator';
function isObject(value) {
    return value != null && (typeof value === 'object' || typeof value === 'function') && !Array.isArray(value);
}
export function isNotEmptyObjectWithLVS(value) {
    if (!isObject(value)) {
        return false;
    }
    for (const key in value) {
        if (value.hasOwnProperty(key)) {
            return true;
        }
    }
    return false;
}
export function IsNotEmptyObjectWithLVS(validationOptions) {
    return ValidateBy({
        name: IS_NOT_EMPTY_OBJECT,
        validator: {
            validate: (value, _args) => isNotEmptyObjectWithLVS(value),
            defaultMessage: buildMessage((eachPrefix) => eachPrefix + '$property must be a non-empty object', validationOptions),
        },
    }, validationOptions);
}
//# sourceMappingURL=IsNotEmptyObjectWithLVS.js.map